/**
 * Render order
 */
export class RaceRenderOrder {
    static ORDER_ATMOSPHERE = 1;
    static ORDER_SHIPS = 2;
    static ORDER_TRAILS = 3;
    static ORDER_FLARES = 4;
}